/**
 * UI gating — spec §I2 ("mirror of server rules, never the enforcement").
 * Nav: Data Manager analyst+ · Administration manager. Both the topbar nav filter and
 * the router guard read these two constants, so they can never drift apart.
 */
import type { Role } from './state';

/** Roles, lowest privilege first (§I1). */
export const ROLE_ORDER: Role[] = ['public', 'field', 'partner', 'analyst', 'manager'];

/** Route → roles allowed to open it. Absent = every role. */
export const ROUTE_ROLES: Partial<Record<string, Role[]>> = {
  '/manager': ['analyst', 'manager'],
  '/admin': ['manager'],
};

export function canAccess(path: string, role: Role): boolean {
  const allowed = ROUTE_ROLES[path];
  return !allowed || allowed.includes(role);
}

/** `atLeast('analyst', role)` — ordering per §I1, used for disabled-with-tooltip states. */
export function atLeast(minimum: Role, role: Role): boolean {
  return ROLE_ORDER.indexOf(role) >= ROLE_ORDER.indexOf(minimum);
}
